var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-module"},[_c(_setup.MerchantLayout,{attrs:{"moduleName":_vm.moduleName}}),_c(_setup.CommonBanner,{attrs:{"moduleName":_vm.moduleName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }